export default __webpack_public_path__ + "static/art-context-graph-OL-mobile2-465eb6ccc638d5c3dda6349b2be73e36.svg";